<div class="flex flex-col items-center gap-4 p-4 text-center sm:p-8">
  <div
    class="flex size-16 items-center justify-center rounded-full bg-[var(--tui-status-positive)] text-2xl text-white"
  >
    OK
  </div>
  <h4 class="x-font-h4">
    {{ 'request_create.success_title' | translate }}
  </h4>
  <p>
    {{ 'request_create.success_number' | translate }}
    <strong>{{ createdRequests()[0]?.requestNumber }}</strong>
  </p>
  <div class="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
    <button
      tuiButton
      type="button"
      size="m"
      class="w-full sm:w-auto"
      appearance="flat"
      (click)="closeDialog.emit()"
    >
      {{ 'request_create.close' | translate }}
    </button>
    <button
      tuiButton
      type="button"
      size="m"
      class="w-full sm:w-auto"
      (click)="navigateToRequest.emit()"
    >
      {{ 'request_create.go_to_request' | translate }}
    </button>
  </div>
</div>
